import styled from 'styled-components';

export const Form = styled.form`
  margin: 2rem 0;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Text = styled.p`
  margin-bottom: 2rem;
`;



// WEBPACK FOOTER //
// ./src/components/SearchInvoiceForm/styledComponents.js